import type { IsFlexUserResponse } from '../entitlementsApi';

type EntitlementsQueryState = {
  data?: unknown;
  status?: string;
};

type RootStateSlice = {
  entitlementsApi: {
    queries: Record<string, EntitlementsQueryState | undefined>;
  };
};

export const selectIsFlexUser = (state: RootStateSlice): boolean => {
  const queryState = state.entitlementsApi.queries[`getIsFlexUser(undefined)`];
  const data = queryState?.data as IsFlexUserResponse | undefined;
  return data?.isFlex ?? false;
};

export const selectIsFlexUserLoading = (state: RootStateSlice): boolean => {
  const queryState = state.entitlementsApi.queries[`getIsFlexUser(undefined)`];
  return !queryState || queryState.status === 'pending';
};

export const selectIsFlexUserError = (state: RootStateSlice): boolean => {
  const queryState = state.entitlementsApi.queries[`getIsFlexUser(undefined)`];
  return queryState?.status === 'rejected';
};

export const selectEntitlements = (state: RootStateSlice): unknown => {
  const queryState = state.entitlementsApi.queries[`getEntitlements(undefined)`];
  return queryState?.data ?? null;
};

export const selectEntitlementsLoading = (state: RootStateSlice): boolean => {
  const queryState = state.entitlementsApi.queries[`getEntitlements(undefined)`];
  return !queryState || queryState.status === 'pending';
};

export const selectEntitlementsError = (state: RootStateSlice): boolean => {
  const queryState = state.entitlementsApi.queries[`getEntitlements(undefined)`];
  return queryState?.status === 'rejected';
};

export const selectProducts = (state: RootStateSlice): unknown => {
  const queryState = state.entitlementsApi.queries[`getAllProducts(undefined)`];
  return queryState?.data ?? null;
};

export const selectProductsLoading = (state: RootStateSlice): boolean => {
  const queryState = state.entitlementsApi.queries[`getAllProducts(undefined)`];
  return !queryState || queryState.status === 'pending';
};

export const selectProductsError = (state: RootStateSlice): boolean => {
  const queryState = state.entitlementsApi.queries[`getAllProducts(undefined)`];
  return queryState?.status === 'rejected';
};
